// Configuration for different environments

// For LOCAL Environment
// const BASEURL = "http://localhost:5000/api";
// const DEP_ENVIRONMENT = "uat";

// For UAT Environment
const BASEURL = "https://mid-test.dep-vygr.com/api";
const DEP_ENVIRONMENT = "uat";

// Common configuration
const AWS_CONFIG_TYPE = true;
const CLOUD_ENVIRONMENT = "AWS";

export { BASEURL, AWS_CONFIG_TYPE, CLOUD_ENVIRONMENT, DEP_ENVIRONMENT };
